module.exports = __webpack_public_path__ + "img/background.80a4b6ab.svg";